export default __webpack_public_path__ + "static/marathon_keyart-6843e90a82411e0ecf81e639f68adbe1.png";